import { UserType } from '@avanta/shared/constants/users';
import type { User } from '@avanta/shared/types/users';
import { ROUTES } from 'constants/routes';

export const isMintHeader = (pathname: string, user: User | null): boolean => {
  if (pathname === ROUTES.PAE || pathname === ROUTES.HOME) return true;
  if (user && user.type !== UserType.PATIENT && user.type !== UserType.EMPLOYEE) return false;
  return false;
};
